import React, { FC } from 'react'
import styles from 'styles/components/calendar.module.scss'
import { ScheduleCalendarHeaderRow, ScheduleCalendarRow } from 'components/Calendar'
import { getCalendarArray } from 'lib/calendar'
import { DayOfWeekType } from 'lib/daysOfWeek'
import { endOfMonth, startOfMonth } from 'date-fns'

type Props = {
  activeDates: Date[]
  businessDays: DayOfWeekType[]
  currentMonth: Date
  individualSettingDates: Date[]
  selectDate: (date: Date) => void
}

const ScheduleCalendar: FC<Props> = (props) => {
  const { activeDates, businessDays, currentMonth, individualSettingDates, selectDate } = props
  const calendar = getCalendarArray(startOfMonth(currentMonth), endOfMonth(currentMonth))

  return (
    <table className={styles.table}>
      <thead>
        <ScheduleCalendarHeaderRow />
      </thead>
      <tbody>
        {calendar.map((row, rowNum) => (
          <ScheduleCalendarRow
            key={rowNum}
            activeDates={activeDates}
            businessDays={businessDays}
            currentMonth={currentMonth}
            individualSettingDates={individualSettingDates}
            row={row}
            selectDate={selectDate}
          />
        ))}
      </tbody>
    </table>
  )
}

export default ScheduleCalendar
